import React from 'react';
import Chip from '@material-ui/core/Chip';
import 'assets/css/lista-itens-parecer.css';

export default function ItensPedidoCirurgia(props) {
  return (
    <div className="div-geral-itens-parecer">
      <div className="lista-itens-parecer">
        {props.itensPedidoCirurgia.map(item => {
          return (
            <Chip
              key={item.id}
              label={item.descricao}
              className="item-parecer"
              style={{
                backgroundColor: item.cor,
              }}
            />
          );
        })}
      </div>
      <div className="lista-legenda-parecer">
        {props.listaStatusItens.map(status => {
          return (
            <div key={status.cor} className="div-quadradinho">
              <div
                className="quadradinho"
                style={{
                  backgroundColor: status.cor,
                  borderColor: status.cor,
                }}
              />
              <span>
                <strong>{status.descricao}</strong>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
